import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table';
import { useSelector } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import { SECONDORY_COLOR } from "../common/sharedFunctions";
export default function Earningreports() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  const settings = useSelector(state => state.settingsdata.settings);

  const columns = [
    {
      title: t('year'), field: 'year',
    },
    {
      title: t('months'), field: 'monthsName',
    },
    {
      title: t('booking_count'), field: 'total_rides',
    },
    {
      title: t('Gross_trip_cost'), render: rowData => (parseFloat(rowData.tripCost) + parseFloat(rowData.cancellationFee)).toFixed(settings.decimal), editable: 'never',

    },
    {
      title: t('trip_cost_driver_share'), field: 'rideCost',

    },
    {
      title: t('cancellationFee'), field: 'cancellationFee',

    },
    {
      title: t('convenience_fee'), field: 'convenienceFee',

    },
    {
      title: t('Discounts'), field: 'discountAmount',

    },
    {
      title: t('Profit'), render: rowData => (parseFloat(rowData.convenienceFee) + parseFloat(rowData.cancellationFee) - parseFloat(rowData.discountAmount)).toFixed(settings.decimal), editable: 'never',

    },
  ];

  const [data, setData] = useState([]);
  const earningreportsdata = useSelector(state => state.earningreportsdata);

  useEffect(() => {
    if (earningreportsdata.Earningreportss) {
      setData(earningreportsdata.Earningreportss);
    }
  }, [earningreportsdata.Earningreportss]);

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    earningreportsdata.loading ? <CircularLoading /> :
      <div style={{ backgroundColor: 'var(--bg-main)', padding: '0 24px 24px 24px' }}>
        
        <MaterialTable
          title={t('earning_reports_title')}
          columns={columns}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "20px",
            boxShadow: "var(--shadow)",
            
            padding: "0",
            backgroundColor: "var(--bg-card)",
            backdropFilter: "blur(12px)",
            border: "var(--card-border)",
            overflow: "hidden"
          }}
          data={data}

          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 15, 20],
            exportButton: true,
            rowStyle: rowData => ({
              backgroundColor: (selectedRow === rowData.tableData.id) ? "var(--table-row-selected)" : "var(--table-row-bg)",
              borderBottom: "var(--table-border)",
              fontSize: "14px",
              color: "var(--text-main)"
            }),
            editable: {
              backgroundColor: colors.Header_Text,
              fontSize: "0.8em",
              fontWeight: 'bold ',
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
            headerStyle: {
              position: "sticky",
              top: "0px",
              background: "var(--table-header-bg)",
              color: "var(--text-light)",
              textAlign: "center",
              fontWeight: "700",
              fontFamily: 'Inter, sans-serif',
              border: "none",
              height: "56px",
              borderBottom: "var(--card-border)"
            },
            cellStyle: {
              borderBottom: "var(--table-border)",
              textAlign: "center",
              padding: "14px",
              color: "var(--text-main)"
            },
            actionsColumnIndex: -1,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: (t('search')),
              exportTitle: (t('export')),
            },
            pagination: {
              labelDisplayedRows: ('{from}-{to} ' + (t('of')) + ' {count}'),
              firstTooltip: (t('first_page_tooltip')),
              previousTooltip: (t('previous_page_tooltip')),
              nextTooltip: (t('next_page_tooltip')),
              lastTooltip: (t('last_page_tooltip'))
            },
          }}

        />
      </div>
  );
}
